import { useTranslation } from 'react-i18next';

import { StaticPageLayout } from '../components/layout/StaticPageLayout';
import { TELEGRAM_SUPPORT_URL } from '../utils/constants';

function Section({
  titleKey,
  children,
}: {
  titleKey: string;
  children: React.ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <section>
      <h2 className="text-xl font-heading font-semibold text-brand-accent mb-3">
        {t(titleKey)}
      </h2>
      <div className="text-neutral-medium font-body leading-relaxed space-y-2">
        {children}
      </div>
    </section>
  );
}

export function SupportPage() {
  const { t } = useTranslation();

  return (
    <StaticPageLayout
      titleKey="staticPages.support.title"
      subtitleKey="staticPages.support.subtitle"
    >
      <p className="text-neutral-medium font-body leading-relaxed">
        {t('staticPages.support.intro')}
      </p>

      {/* كرت التواصل مع الدعم عبر تيليجرام */}
      <div className="mt-8 rounded-2xl border-2 border-brand-accent/40 bg-brand-accent/10 p-6 md:p-8 shadow-xl shadow-brand-accent/10">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 rounded-2xl bg-brand-accent/20 flex items-center justify-center mb-4">
            <svg
              className="w-9 h-9 text-brand-accent"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden
            >
              <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.12l-6.87 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z" />
            </svg>
          </div>
          <h3 className="text-xl font-heading font-bold text-brand-accent mb-2">
            {t('staticPages.support.ctaTitle')}
          </h3>
          <p className="text-neutral-medium font-body mb-6 max-w-lg">
            {t('staticPages.support.ctaDescription')}
          </p>
          <a
            href={TELEGRAM_SUPPORT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-brand-accent text-brand-primary font-heading font-semibold rounded-xl hover:shadow-lg hover:shadow-brand-accent/50 transform hover:scale-105 transition-all duration-300"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden>
              <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 8.221l-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.12l-6.87 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z" />
            </svg>
            {t('staticPages.support.ctaButton')}
          </a>
        </div>
      </div>

      <Section titleKey="staticPages.support.channels">
        <p><strong className="text-neutral-light">{t('staticPages.support.telegram')}:</strong> {t('staticPages.support.telegramDesc')}</p>
        <p><strong className="text-neutral-light">{t('staticPages.support.email')}:</strong> {t('staticPages.support.emailDesc')}</p>
      </Section>
      <Section titleKey="staticPages.support.hours">
        <p>{t('staticPages.support.hoursText')}</p>
      </Section>
      <Section titleKey="staticPages.support.faq">
        <p>{t('staticPages.support.faqText')}</p>
      </Section>
    </StaticPageLayout>
  );
}
